import axios from 'axios'
import 'url-search-params-polyfill'
import _ from 'lodash'

import createReservation, { createReservationBegin } from './createReservation'
import apiConfiguration from '../utilities/api/apiConfiguration'
import accorInitializeDsp2Payment from '../utilities/payment/accorInitializeDsp2Payment'

export const FETCH_TRANSACTION_TOKEN_BEGIN   = 'FETCH_TRANSACTION_TOKEN_BEGIN'
export const FETCH_TRANSACTION_TOKEN_SUCCESS = 'FETCH_TRANSACTION_TOKEN_SUCCESS'
export const FETCH_TRANSACTION_TOKEN_FAILURE = 'FETCH_TRANSACTION_TOKEN_FAILURE'
export const FETCH_PSP_SESSION_ID_LOADING = 'FETCH_PSP_SESSION_ID_LOADING'
export const SET_PSP_SESSION_ID = 'SET_PSP_SESSION_ID'

export const fetchTransactionTokenBegin = () => ({
	type: FETCH_TRANSACTION_TOKEN_BEGIN,
})

export const fetchTransactionTokenSuccess = transactionToken => ({
	type: FETCH_TRANSACTION_TOKEN_SUCCESS,
	payload: transactionToken
})

export const fetchTransactionTokenError = error => ({
	type: FETCH_TRANSACTION_TOKEN_FAILURE,
	payload: { error }
})

export const fetchPspSessionIdLoading = isLoading => dispatch => {
	dispatch({ type: FETCH_PSP_SESSION_ID_LOADING, payload: isLoading })
}

export const setPspSessionId = pspSessionId => dispatch => {
	dispatch({ type: SET_PSP_SESSION_ID, payload: pspSessionId })
}

// Handle Availability Fetch & Functionality
export default function fetchTransactionToken(
	// paymentFormData,
	// handlePspSessionId,
	// submitReservationForm
	renewedSessionId
) {
	return (dispatch, getState) => {
		const urlData = getState().availabilityData.urlData
		const pspSessionId = _.get(getState(), 'transactionTokenData.pspSessionId')
		const transactionToken = _.get(getState(), 'transactionTokenData.tokens')
	
		let clientId = null
		let hotelCode = _.get(urlData, 'hotelCode', '')
		if (
			process.env.REACT_APP_FLOW_CLIENT_ID &&
			process.env.REACT_APP_FLOW_CLIENT_ID !== 'null'
		) {

			clientId = process.env.REACT_APP_FLOW_CLIENT_ID
		}
		// URL Params
		let urlParams = {
			hotelCode: hotelCode,
			clientId: clientId
		}

		// Fetch Query string method
		const fetchQuery = new URLSearchParams()

		// Loop urlParams for undefined values & remove

		for (let key in urlParams) {
			if (typeof urlParams[key] === "undefined") continue
			fetchQuery.append(key, urlParams[key])
		}
		// Base API path
		const transactionApi = process.env.REACT_APP_FLOW_ENDPOINT_URL + '/api/hotel/transaction-token?' + fetchQuery.toString()

		// dispatch(createReservationBegin)
		dispatch(fetchTransactionTokenBegin())

		function handleCreateReservation() {
			dispatch(createReservation(renewedSessionId))
		}

		function handlePspSessionId(pspSessionId) {
			dispatch(setPspSessionId(pspSessionId))
		}

		let getTransactionToken = () => axios.get(transactionApi, apiConfiguration())
			.then(response => {
				const res = _.get(response, 'data["hydra:member"][0]', [])
				const jwtToken = _.get(res, 'id', null)

				// the beging creare reservation action is dispatched here to maintain a constant
				// loading spinner otherwise, the use of cardinal interrupts the process.
				dispatch(createReservationBegin)

				if (jwtToken) {
					accorInitializeDsp2Payment(
						jwtToken,
						handlePspSessionId,
						handleCreateReservation,
					)
				} else {
					handleCreateReservation()
				}
				return res
			})
		
		if (
			process.env.REACT_APP_COMPONENT_DSP2_PROVIDER === 'accor'
			&& pspSessionId
			&& transactionToken
		) {
			getTransactionToken = () => {
				handleCreateReservation()
				return Promise.resolve(transactionToken)
			}
		}

		return getTransactionToken()
			.then(response => dispatch(fetchTransactionTokenSuccess(response)))
			.catch(error => dispatch(fetchTransactionTokenError(error)))
	}
}


// WEBPACK FOOTER //
// ./src/actions/fetchTransactionToken.js